import { Maybe } from 'maybe-not';
import MessageBus from '../utility/message-bus';
import { OpenAppArgs } from '../types';

export default function openAppSetup(messageBus: MessageBus, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('openApp')) {
        return;
    }

    return function openApp(params: OpenAppArgs): void {
        if (params.redirectToAppStore === undefined) {
            params.redirectToAppStore = true;
        }
        messageBus.sendRequest<void>(
            `executeDynamicPlatformAPI`,
            Maybe.just({ functionName: 'openApp', args: [JSON.stringify(params)] }).map(
                JSON.stringify
            )
        );
    };
}
